import { render, staticRenderFns } from "./AddonProduct.vue?vue&type=template&id=44cfbd24&scoped=true&"
import script from "./AddonProduct.vue?vue&type=script&lang=js&"
export * from "./AddonProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddonProduct.vue?vue&type=style&index=0&id=44cfbd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cfbd24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\occasion-shop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44cfbd24')) {
      api.createRecord('44cfbd24', component.options)
    } else {
      api.reload('44cfbd24', component.options)
    }
    module.hot.accept("./AddonProduct.vue?vue&type=template&id=44cfbd24&scoped=true&", function () {
      api.rerender('44cfbd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "OccasionShop/components/AddonProduct.vue"
export default component.exports